import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import Exclusive_collection from '../../../Assets/images/cultured-img/landing-page-img/engagment-static-page-img/exclusive_collection.png'

const ExclusiveCollection = () => {
    return (
        <>
            <div className='dfl_eng_exclusive_collection_section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={6} lg={6}>
                            <div className='eng-inner-banner-text text-center'>
                                <h2 className="title32 dark">Exclusive Collection</h2>
                                <h2 className="title30 dark text-uppercase play-font mtop20">up to 30% off</h2>
                                <p className="dark both-pr">Our extraordinary collection of engagement rings spans timeless styles to the latest trends, including solitaire, vintage, halo and more.</p>
                                <div className="btn-wrapper text-uppercase row text-center">
                                    <div className=" col-xs-12 text-center m-auto w-100"> <NavLink className="btn-engage w-100" to="/ringsettings"> Explore Our Collection </NavLink> </div>
                                </div>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6} className="p-0">
                            <div className="banner-adv banner-adv2 zoom-image">
                                <NavLink to="/ringsettings" className="adv-thumb-link"><img src={Exclusive_collection} className="img-fluid" alt="exclusive_collection" /></NavLink>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default ExclusiveCollection